import { alpha } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";
import type { SxProps } from "@mui/material";

type HomeStyles = Record<string, SxProps<Theme>>;

export const homeStyles: HomeStyles = {
  root: {
    mx: "auto",
    width: "100%",
    maxWidth: 1600,
    p: { xs: 2, sm: 3, lg: 4 },
  },
  hero: (theme) => ({
    position: "relative",
    overflow: "hidden",
    mb: 3,
    p: { xs: 2.5, md: 3.5 },
    border: `1px solid ${alpha(theme.palette.secondary.main, 0.16)}`,
    borderRadius: 3,
    background: `linear-gradient(120deg, ${alpha(
      theme.palette.secondary.main,
      0.1,
    )}, ${alpha(theme.palette.secondary.light, 0.03)} 58%, transparent)`,
    "&::after": {
      content: '""',
      position: "absolute",
      width: 220,
      height: 220,
      right: -70,
      top: -105,
      borderRadius: "50%",
      backgroundColor: alpha(theme.palette.secondary.main, 0.08),
    },
  }),
  eyebrow: (theme) => ({
    color: theme.palette.secondary.main,
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
  }),
  title: {
    mt: 0.5,
    fontWeight: 900,
    letterSpacing: "-0.04em",
  },
  heroText: {
    mt: 1,
    maxWidth: 680,
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "repeat(2, minmax(0, 1fr))",
      xl: "repeat(4, minmax(0, 1fr))",
    },
    gap: 2,
    mb: 4,
  },
  statCard: (theme) => ({
    minHeight: 168,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 3,
    boxShadow: "none",
    transition: theme.transitions.create(["transform", "box-shadow"], {
      duration: theme.transitions.duration.shorter,
    }),
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: `0 14px 34px ${alpha(theme.palette.common.black, 0.08)}`,
    },
  }),
  iconBadge: (theme) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 42,
    height: 42,
    borderRadius: 2.25,
    color: theme.palette.secondary.main,
    backgroundColor: alpha(theme.palette.secondary.main, 0.1),
  }),
  sectionTitle: {
    mb: 2,
    fontWeight: 800,
  },
  actionsGrid: {
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      md: "repeat(2, minmax(0, 1fr))",
    },
    gap: 2,
  },
  actionCard: (theme) => ({
    display: "flex",
    alignItems: "center",
    minHeight: 116,
    p: 2.5,
    color: "inherit",
    textDecoration: "none",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 3,
    backgroundColor: theme.palette.background.paper,
    transition: theme.transitions.create(["border-color", "background-color"]),
    "&:hover": {
      borderColor: alpha(theme.palette.secondary.main, 0.45),
      backgroundColor: alpha(theme.palette.secondary.main, 0.025),
    },
  }),
};
